import { onMounted, onUnmounted, ref } from "vue";

/**
 * Хук для отслеживания размеров окна браузера.
 * @returns Объект с реактивными значениями ширины и высоты окна.
 */
export const useWindowSize = () => {
  /**
   * Реактивная переменная для хранения ширины окна.
   * Инициализируется текущей шириной окна.
   */
  const windowWidth = ref<number>(window.innerWidth);

  /**
   * Реактивная переменная для хранения высоты окна.
   * Инициализируется текущей высотой окна.
   */
  const windowHeight = ref<number>(window.innerHeight);

  /**
   * Обработчик события `resize`.
   * Обновляет значения ширины и высоты при изменении размеров окна.
   */
  const onResize = () => {
    windowWidth.value = window.innerWidth;
    windowHeight.value = window.innerHeight;
  };

  /**
   * Подписка на событие `resize` при монтировании компонента.
   */
  onMounted(() => {
    window.addEventListener("resize", onResize);
  });

  /**
   * Отписка от события `resize` при размонтировании компонента.
   */
  onUnmounted(() => {
    window.removeEventListener("resize", onResize);
  });

  return {
    /**
     * Реактивная переменная для хранения ширины окна.
     * Инициализируется текущей шириной окна.
     */
    windowWidth,
    /**
     * Реактивная переменная для хранения высоты окна.
     * Инициализируется текущей высотой окна.
     */
    windowHeight,
  };
};
